module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon5.c0e93580.svg";